import React, { useState } from 'react';
import { Link } from 'gatsby';

import * as styles from './SideMenu.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { removeItem } from '../utils/utils';
import { useTranslation } from 'react-i18next';

interface Entry {
  title: string;
  url: string;
  isActive: boolean;
  entries?: never;
}

interface SubMenuEntry {
  title: string;
  entries: Array<Entry>;
}

interface SideMenuProps {
  entries: Array<Entry | SubMenuEntry>;
}

const SideMenu = ({ entries }: SideMenuProps): React.ReactElement => {
  const { t } = useTranslation();

  const activeAccordionIndex = entries.findIndex(entry =>
    entry.entries?.some(entry => entry.isActive),
  );

  const [openAccordionIndexes, setOpenAccordionIndexes] = useState(
    activeAccordionIndex === -1 ? [] : [activeAccordionIndex],
  );

  return (
    <>
      <div className={styles.container}>
        {entries.map((entry, i) =>
          entry.entries ? (
            <div
              key={i}
              className={
                styles.accordion +
                ' ' +
                (openAccordionIndexes.includes(i) ? styles.accordionOpen : '')
              }
            >
              <div
                className={
                  styles.accordionBox + ' ' + (activeAccordionIndex === i ? styles.selected : '')
                }
                onClick={() => {
                  setOpenAccordionIndexes(
                    openAccordionIndexes.includes(i)
                      ? removeItem(openAccordionIndexes, i)
                      : [...openAccordionIndexes, i],
                  );
                }}
              >
                {entry.title}
                <FontAwesomeIcon icon="chevron-down" className={styles.icon} />
              </div>
              <div className={styles.body}>
                {entry.entries.map((subMenuEntry, i) => (
                  <Link
                    key={i}
                    to={subMenuEntry.url}
                    className={
                      styles.subMenuEntry + (subMenuEntry.isActive ? ' ' + styles.selected : '')
                    }
                  >
                    <div className={styles.barb}></div>
                    {subMenuEntry.title}
                    <div className={styles.line}></div>
                  </Link>
                ))}
              </div>
            </div>
          ) : (
            <Link
              key={i}
              to={entry.url}
              className={styles.entry + (entry.isActive ? ' ' + styles.selected : '')}
            >
              {entry.title}
            </Link>
          ),
        )}
      </div>
    </>
  );
};

export default SideMenu;
